import { useState } from 'react';
import { trackEvent } from '@v2/shared/lib/analytics';
import { recordFeedback } from './kustomer';
import { HelpKustomer } from './types';

export type FeedbackProps = {
  kustomer: HelpKustomer;
  articleId: string;
  slug: string;
};

/**
 * "Was this article helpful?", recorded in Kustomer.
 *
 * Thanks the reader whatever Kustomer said: the vote is not something they can retry or
 * fix, so an error message would only report our problem as their failure.
 */
export default function Feedback({ kustomer, articleId, slug }: FeedbackProps) {
  const [answered, setAnswered] = useState(false);

  const answer = (helpful: boolean) => {
    setAnswered(true);
    trackEvent('help_article_feedback', { slug, helpful });
    recordFeedback(kustomer, articleId, helpful);
  };

  return (
    <div className="flex flex-wrap items-center gap-2.5">
      <strong className="mr-1.5 text-base text-slate-900">Was this article helpful?</strong>

      {answered ? (
        <span className="text-sm text-slate-500">Thanks for letting us know.</span>
      ) : (
        <span className="inline-flex gap-2">
          <button
            type="button"
            className="cursor-pointer rounded-lg border border-solid border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-900 hover:border-primary hover:text-primary"
            onClick={() => answer(true)}
          >
            Yes
          </button>
          <button
            type="button"
            className="cursor-pointer rounded-lg border border-solid border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-900 hover:border-primary hover:text-primary"
            onClick={() => answer(false)}
          >
            No
          </button>
        </span>
      )}
    </div>
  );
}
